class FoldContent extends HTMLElement {
  constructor() {
    super();
    let isShow = false;
    const lists = this.querySelectorAll('li');
    const btn = this.querySelector('[data-show]');
    
    const toggleText = {
      open: 'Close',
      hide: 'More'
    }
    
    if (lists.length > 3) {
      btn.addEventListener('click', () => {
        this.classList.toggle('show', isShow = !isShow);
        btn.innerHTML = isShow ? toggleText.open : toggleText.hide;
      })
    }else {
      btn.classList.add('uk-hidden');
    }
  }
  
}

customElements.define('fold-content', FoldContent);
